import React, { useEffect, useMemo, useState } from 'react'
import {
  OrderTransactionListItem
} from 'components/Order/OrderDetails/OrderTransactionsList/OrderTransactionListItem/OrderTransactionListItem'
import {
  TransactionType
} from 'components/Order/OrderForms/OrderForm/OrderTransactionsForm/OrderTransactionsGroupForm/OrderTransactionForm/TransactionType'
import { FormRow } from 'components/Shared/CrudComponents'
import styles from 'components/Order/OrderDetails/OrderTransactionsList/OrderTransactionsList.module.css'
import {
  ContainerColumn
} from 'components/Order/OrderForms/OrderForm/OrderPointsForm/OrderPointsGroupForm/OrderPointForm/ContainerColumn'
import { useTranslation } from 'react-i18next'
import { useErrorHandling } from 'context/errorHandling'
import { fetchTransactionServices } from 'services'
import { ORDER_COST_READ, ORDER_INCOME_READ, useAuth } from 'context/auth'

export function OrderTransactionsList ({ transactions }) {
  const { t } = useTranslation()
  const incomes = useMemo(() => transactions?.filter(ot => ot.transactionType === TransactionType.Income), [transactions])
  const costs = useMemo(() => transactions?.filter(ot => ot.transactionType === TransactionType.Cost), [transactions])
  const transactionLabels = {
    INCOME: 'form.order.transaction.orderTransactionType.INCOME',
    COST: 'form.order.transaction.orderTransactionType.COST'
  }

  const [transactionServiceTypes, setTransactionServicesTypes] = useState(null)

  const { handleError } = useErrorHandling()
  const { hasAnyPrivileges } = useAuth()

  useEffect(() => {
    fetchTransactionServices()
      .then(setTransactionServicesTypes)
      .catch(handleError)
  }, [handleError])

  return (
    <>
      <FormRow>
        {transactions?.length > 0 ?
          <>
            {hasAnyPrivileges([ORDER_INCOME_READ]) && incomes?.length > 0 &&
              <div className={styles.root}>
                <ContainerColumn>
                  {
                    new Array(Math.max(incomes.length))
                      .fill(1)
                      .map((_, index) =>
                        <OrderTransactionListItem
                          key={index}
                          transaction={incomes[index]}
                          number={index + 1}
                          transactionServiceTypes={transactionServiceTypes}
                          title={transactionLabels.INCOME}/>)
                  }
                </ContainerColumn>
              </div>
            }
            {hasAnyPrivileges([ORDER_COST_READ]) && costs?.length > 0 &&
              <div className={styles.root}>
                <ContainerColumn>
                  {
                    new Array(Math.max(costs.length))
                      .fill(1)
                      .map((_, index) =>
                        <OrderTransactionListItem
                          key={index}
                          transaction={costs[index]}
                          number={index + 1}
                          transactionServiceTypes={transactionServiceTypes}
                          title={transactionLabels.COST}/>)
                  }
                </ContainerColumn>
              </div>
            }
          </>
          : <div className={styles.noDataContainer}>{t(`form.order.transaction.noData`)}</div>
        }
      </FormRow>
    </>
  )
}
